module.exports = __webpack_public_path__ + "static/media/morty-snout.6dfd0238.png";